import React from 'react';

class RightStickerContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      style : {},
      fixedTop: 0,
      item: {},
      wrapItem: {},
      footer: {},
      main: {},
      header: {}
    }
  }

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    this.initPosition();
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    this.resize()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  resize() {
    let Main = document.getElementById('main');
    let FixedTop = Main.getBoundingClientRect().height - this.props.offsetBottom + this.state.header.height - this.state.item.top - this.state.item.height;
    this.setState({
      fixedTop: FixedTop
    })
  }

  initPosition() {
    document.getElementById('rightSticker').classList.add("rightSticker");
    setTimeout(() => {
      let Item = document.getElementById('rightSticker');
      let WrapItem = document.getElementById('rightStickerWrap');
      let Footer = document.getElementById('footer');
      let Main = document.getElementById('main');
      let Header = document.getElementById('header');
      let FixedTop = Main.getBoundingClientRect().height - this.props.offsetBottom + Header.getBoundingClientRect().height - Item.getBoundingClientRect().top - Item.getBoundingClientRect().height;

      this.setState({
        item: Item.getBoundingClientRect(),
        wrapItem: WrapItem.getBoundingClientRect(),
        footer: Footer.getBoundingClientRect(),
        main: Main.getBoundingClientRect(),
        header: Header.getBoundingClientRect(),
        fixedTop: Number(FixedTop)
      },()=> {
        document.getElementById('rightSticker').classList.remove("rightSticker");
      })
    }, 100);
  }

  handleScroll(event) {
    if(this.RightSticker) {
      let Item = document.getElementById('rightSticker');
      let WrapItem = document.getElementById('rightStickerWrap');
      let Footer = document.getElementById('footer');
      let Main = document.getElementById('main');
      let Header = document.getElementById('header');
      let Top = (WrapItem.getBoundingClientRect().y * -1);

      if (Footer.getBoundingClientRect().top < (Item.getBoundingClientRect().height)) {
        let newStyle = "position:absolute;width:100%;top:" + this.state.fixedTop + "px";
        Item.style.cssText = newStyle
      } else {
        if (WrapItem.getBoundingClientRect().top < this.props.offsetTop) {
          let newStyle = "position:absolute;width:100%;top:" + Top + "px";
          Item.style.cssText = newStyle
        } else if (WrapItem.getBoundingClientRect().top > this.props.offsetTop) {
          Item.removeAttribute("style")
        }
      }
    }
  }

  render() {
    return (
      <div ref={(RightSticker) => { this.RightSticker = RightSticker; }} className="right-sticker-container-wrap" id='rightStickerWrap' style={{position: 'relative'}}>
        <div className='right-sticker-container' id='rightSticker'>
          {
            this.props.children
          }
        </div>
      </div>
    );
  }
}

RightStickerContainer.defaultProps = {
  offsetTop: 0,
  offsetBottom: 35
}

export default RightStickerContainer;


// WEBPACK FOOTER //
// ./components/partials/right-sticker/RightStickerContainer.jsx